// This file is part of the Smart Building Message Gateway.
//
//   |     __| _ _|   __|   _ \   \  |
//   |     _|    |   (     (   | |\/ |
//  ____| ___| ___| \___| \___/ _|  _|
//
// Copyright © 2025 LEICOM AG. All Rights Reserved.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
// BUT NOT LIMITED  TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// @author      Christian Stauffer <christian.stauffer@leicom.ch>, et al.

import { React, useEffect, useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { RiSettings5Line , RiLogoutBoxRLine, RiUser3Fill } from "react-icons/ri";
import { LuBotMessageSquare } from "react-icons/lu";
import { BiStats } from "react-icons/bi";
import { VscRemoteExplorer } from "react-icons/vsc";


import './Menu.css';

import logo from './assets/images/logo_512.png';

function Menu() {

  const navigate = useNavigate();
  const location = useLocation();

  const [version, setVersion] = useState('-');
  
  const { token } = location.state || {};
 
  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  // get version
  useEffect(() => {
    async function fetchVersion() {
      try {      
        const response = await fetch(`${api}/version`, {
          method: "GET",
          headers: {
            "X-Api-Key": `${apiKey}`,
          },
        });
        const versJ = await response.json()
        console.log("Leicom AG - Smart Building Message Gateway - Version",versJ['version'])
        setVersion(versJ['version'])
      } catch (err) {
        alert("network problems")
        return (<Navigate to="/login" />);
      }
    }
    fetchVersion();
  }, [apiKey, api]);

  // no login, no content site
  if ( token === undefined ) {
    return (<Navigate to="/login" />);
  }

  // logout handler
  const handleLogout = async (e) => {
    e.preventDefault();
    
    // setLoading(true);
    
    try {      
      const response = await fetch(`${api}/logout`, {
        method: "POST",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`,
        },
      });
            
      if (response.ok) {
        // alert("successful")
      } else {
        alert("logout was not successful")
      }
    } catch (err) {
      // setError('network error')
      alert("network problems")
    } finally {
      // setLoading(false)
      navigate("/login");
    }
  };

  //
  // page handles
  //
  const gotoMessage = (e) =>{
    navigate("/message", { state: { token }});
  }

  const gotoConfiguration = (e) =>{
    navigate("/configuration", { state: { token }});
  }

  const gotoUser = (e) =>{
    navigate("/user", { state: { token }});
  }

  const gotoStats = (e) =>{
    navigate("/stats", { state: { token }});
  }

  const gotoRemote = (e) =>{
    navigate("/remote", { state: { token }});
  }

  return (
    <nav className="menu">
      <div>
        <img src={logo} alt="Logo" className="menu-logo" />
      </div>
      <ul>
        <li>
          <button onClick={gotoMessage} className="menu-button mmessage">
            <LuBotMessageSquare className="menu-icon" /><br></br>
            <span className="menu-text">Message</span>
          </button>
        </li>

        <li>
          <button onClick={gotoConfiguration} className="menu-button mconfig">
            <RiSettings5Line className="menu-icon" /><br></br>
            <span className="menu-text">Configuration</span>
          </button>
        </li>

        <li>
          <button onClick={gotoUser} className="menu-button muser">
            <RiUser3Fill className="menu-icon" /><br></br>
            <span className="menu-text">User</span>
          </button>
        </li>
        <li>
          <button onClick={gotoStats} className="menu-button mstats">
            <BiStats className="menu-icon" /><br></br>
            <span className="menu-text">Stats</span>
          </button>
        </li>
        <li>
          <button onClick={gotoRemote} className="menu-button mremote">
            <VscRemoteExplorer className="menu-icon" /><br></br>
            <span className="menu-text">Remote</span>
          </button>
        </li>
      </ul>
      <br></br><br></br><br></br>
      <button onClick={handleLogout} className="menu-button" >
        <RiLogoutBoxRLine className="menu-icon" /><br></br>
        <span className="menu-text">Logout</span>
      </button>

      <li><p>Version: {version}</p></li>

    </nav>
  );
}

export default Menu;
